import { useMemo } from 'react'
import { useParams, Outlet, NavLink } from 'react-router-dom'
import * as actions from '@actions'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import SettingsWrapper from '@components/settings/SettingsWrapper'

const Organization = () => {
    
    const params = useParams()
    const {
        data: organization,
        error: organizationError,
        isLoading: organizationIsLoading,
        refetch: fetchOrganization,
    } = useQuery({
        queryKey: ['organization', params?.orgId],
        queryFn: async () => {
            try {
                return await actions.fetchOrgById(params.orgId)
            } catch (e) {
                console.error('fetchOrganization', e)
                toast.error('Failed to fetch organization')
                throw e
            }
        },
        retry: 3,
    })
    
    const links = useMemo(() => {
        
        const prefix = `/settings/orgs/${params?.orgId}`
        
        return [
            { path: prefix, title: 'Members', props: { end: true } },
            { path: `${prefix}/billing`, title: 'Billing' },
            { path: `${prefix}/templates`, title: 'Export Template' },
        ]
        
    }, [params])
    
    return (
        
        <SettingsWrapper
            title="Organization"
            subtitle={organization?.name ?? ''}
            rightContent={
                <div className="flex">
                    <div className="tabs tabs-boxed" role="tablist">
                        {links.map(it => (
                            <NavLink
                                key={it.path}
                                className={({ isActive }) => `tab ${isActive ? 'tab-active' : ''}`}
                                role="tab"
                                to={it.path}
                                {...(it.props ?? {})}>
                                {it.title}
                            </NavLink>
                        ))}
                    </div>
                </div>
            }>
            
            {organizationIsLoading && (
                <div className="absolute-centered loading loading-spinner loading-xs" />
            )}
            
            {organizationError && (
                <div className="absolute-centered text-red-500">
                    Failed to fetch organization
                </div>
            )}
            
            {!organization && !organizationError && !organizationIsLoading && (
                <div className="absolute-centered text-red-500">
                    Failed to fetch organization
                </div>
            )}
            
            {organization && !organizationError && !organizationIsLoading && (
                <Outlet context={{
                    organization,
                    organizationError,
                    organizationIsLoading,
                    fetchOrganization,
                }} />
            )}
        
        </SettingsWrapper>
        
    )
    
}

export default Organization
